import { makeAutoObservable } from 'mobx';
import { z } from 'zod';
import extractValue, {
  type EventOrValue,
} from '../../../../../store/utils/extractValue';
import Validator, {
  type ValidatorErrors,
} from '../../../../../store/utils/Validator';
import { getFirstMonthDay } from '../../../../../utils/date';
import type { PromotionDto } from '../../../../promotions/store/Promotion';
import type User from '../../../store/User';

export default class Bill {
  static Schema = z
    .object({
      endDate: z.coerce.date(),
      startDate: z.coerce.date(),
    })
    .superRefine((data, ctx) => {
      if (data.endDate < data.startDate) {
        ctx.addIssue({
          code: 'custom',
          path: ['endDate'],
          message: 'must be greater than or equal to start date',
        });
      }
    });

  endDate = new Date();
  startDate = getFirstMonthDay();

  private readonly validator = new Validator(this, Bill.Schema);

  constructor(readonly provider?: User) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.validator.validate();
  }

  get errors(): ValidatorErrors<PromotionDto> {
    return this.validator.errorsForEnabledFields;
  }

  get isValid(): boolean {
    return this.validator.isValid;
  }

  get allErrorsAsStrings(): string[] {
    return this.validator.allErrorsAsStrings;
  }

  handleChange(e: EventOrValue) {
    const { name, value } = extractValue(e);

    Object.assign(this, { [name]: value });

    this.validator.validate();
  }

  handleBlur(e: EventOrValue<keyof Bill>) {
    const { name } = extractValue(e);
    this.validator.enableFieldValidation(name);
  }
}
